import React, { useEffect, useRef } from 'react'
import { updateKYCPatient } from '../../_actions/sso.authen';
import { DecryptedOBJ, DecryptedText } from '../../utils/Encryption';

function KYC_TESTUPDATE() {
    let onceMount = useRef(true);

    useEffect(() => {
        if(onceMount.current)
        {
            // console.log(DecryptedOBJ('fKnOaknAk+jHMQq7dqzEIZN+Dy47Mc2PJtj7W5Akf6BzjhoO6ou+1AvTWPw6E+JMospj+AluRRoVJGXwN/2zAR+WGRSw0R4HqKPlow7JvZslUr+wDg/Ulwg1pQoOdu458MPY/2Xe6u4RddJLLq+BuzgILUxpHXZF1xhLl4UgE6U5npo9OqRX9V9IaOnAM2Ln2W+7CnkcLV43tcB2e60DaqoNlIdPP6mkIrnZoYK+ctDYnR6iNxIlgwdd2fq/6CFPEFr/XyyVSi950Bxas6pJTpilDuGCkCqx3sJ9L2CX1YwsiVsyHd90wTXKKaCW+g+QZlVitkLSIXP1kKKz1KUypQKPbTBBWpM+u/L+GmtnfG1BraBktueZeD3dmrylcL+Jc0oGpjmxwmQqy6btF/k2G2LT6wtv2ZUR38xwjw2YicTlsLuj7C00XfXaCN+A9e/WIZGg4KVP/U5zD05wnNDDWAJy9B8CxZsqYnqqZkz8WvUqGjEyphIgyqWWjY632UcXDepCM45LbAwaJ+wuo8Au+1eefFQCBrlA110atWhqPXYgZtBZ7gvbbr/4W/miT5djxJfwvLGneE2oN2V/HJqP4P3FnoA5T9V+2xN4KRqxKmnWlfEkDW6/fp/IMxMyjm/0eyD0WSK1eslCg3KJFwBu++i/qZAu0PnCmS1CXqCpju06IRu8PdvmJ1+A6SzkW+ZF9NewPQIskQrMG3n2vdQSNL9PKi2x2OQkHJELDafekRGhlKE8KTSMzIbp7ZwHx2ASiQNnAT+CYSStbArsXR3cuaTClL1Lfr6rZatfTOfBE6yrj9oozKXm0N01ejgzrq683inUZKZURnBv2jDyYRJs7q80SyhwXQ177EYr2CVMACixjgvsuTNDzdccSoDnXpeCa4LNeqtP0iY/1a0/Kd5H2hQsi1V9le7Cr3Yb4eYUpOie4BwS0Pqr5B4YGSlZO1axrezOlRDY2aJtz2TKPY803CRvB9RmMP0CcPC4VJSYDWBboKo7U559beOHhyRZfW/N1ptD2sHHTizC6T5XM9tdmbUgeD8CShFdP+QfPtMdVGd7LPW4Cgrdnsb3iqt2lh/ij9eAkPQFChDD8Xd8ZA5Es9LpiSZfhVnueC49elgNkVlqX9RAcDjxwuzArUsGsKwZ6ddmPjYTri/eSzxqXkiHCukuiBDwgag7SeNxltV47WgQF9g2WYpWpmYmavMUvokBPLOVgE9ippxcTG0ipJ1z0Krti8QD2uXwDzY83yZtlSUJF5kbm8SMrXHddbgY2pBB+GpWl8zgwLpD1agPHFv4v2IzDJ/6tN4/qPQ8GmvYl0bymgSSSxwJ8odm9T7vvoo2lheqYlYwdYxyGjl00ItDVS6P5MddN0olJcYb5XSC1ApLH6zK/erlE3Ju+L7teXneSI2RWr+z49gkuYMUV0SDHguAG88NRW5aYxtpCzWYHlrIHa+TSCVc+/Qb0Y2q8mgi/NSv7AJhgTYzqWyoEaGABxh9WJEYFFfBpFCX75MRHJ66fNtq1RsfEKpVoRDlkF/VHTOCzf6N0BSGccq+SvLPWYj8M++xXvCaTWZ5jlL2MtV4e0fkLTB8WEYZDNVMuvnNuG2TjB9sC0/KqCoPCvt1ho0TKR8tqFXG4jSwYnzWATMT6uI9a7Zv0KH0wLu05MZeWJe5BZt9cPNQG/k+cK+U04LUh+sL7K5ZpSjOhIaY1Kc/A0gYs2oN2Tr++fDvOKcJYf+Z/Vrk4RUyUh1S51QLFw8H8QzG5p/jpPQk3t4OGWXZOGYAkZOKpzjbyyP0Wpwu'));
            // console.log(DecryptedText('=8EdvRERqtyMxRHMHBFNuxWZ4oFaxpXNIFFdl9icGp3SKxWWQVXcP10QDRUNk1WdJVzQpllRkVEUpNkTRZmUkRVcBFnQrZXcGFFZGNlQNN1dRhzczgEUOpnS2g0NvYnSHlWcnpVauplavdzcwhHcpZVQzNXRz8mMFllajJWO3Z1R1gjVOBTSFlkdht2SiZDUrJ2Rnp0bR1TP'));
            updateKYC();
            onceMount.current = false;
        }
    }, [])

    const updateKYC = async() => {
        let refVerify = {
            "refEXP": "==wNpVFZ2cTQaJ3QCdERjxGNvx2cEZGVqZlbxF2QChmZYd3KK1ENLh0Q2UjdyQ2NzR0RTZzYtZDVwYWTTlHOBxUY",
            "statusCode": 200,
            "isType": 2,
            "refAction": "=cTaVRmN3EkWyNkQHR0YsRzbsNHRmp1aBhWZpp0LxdnUz8yY4onMalFOENWP",
            "refType": "==QO5MnWpJXZNVGc44kRVV2Tvg2NqlTdkJUYiVVZpVnMot2cvsGaulVarhUOrYHNhtCStV0UyoFTIVXYaVDOp1kT",
            "IsSuccess": true,
            "ErrCode": 0,
            "isShow_ErrCode": false,
            "ErrMessage": "",
            "TechnicalErrMessage": ""
        }
        await updateKYCPatient(refVerify)
        .then(() => {
            alert('kyc updated!!')
        })
    }

  return (
    <div>

    </div>
  )
}

export default KYC_TESTUPDATE